"use client";

import { createContext } from "react";

interface UserIdContextProps {
    userId: string | null;
    setUserId: (userId: string) => void;
    isLoading: boolean;
    resetUserId: () => void;
}

export const UserIdContext = createContext<UserIdContextProps | undefined>(
    undefined
);
